import { render, staticRenderFns } from "./YouzhicaiOrder.vue?vue&type=template&id=e2af0c08&scoped=true"
import script from "./YouzhicaiOrder.vue?vue&type=script&lang=js"
export * from "./YouzhicaiOrder.vue?vue&type=script&lang=js"
import style0 from "./YouzhicaiOrder.vue?vue&type=style&index=0&id=e2af0c08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2af0c08",
  null
  
)

export default component.exports